module.exports = __webpack_public_path__ + "static/img/yellow-ballon.31fcd09.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/yellow-ballon.jpg
// module id = UpxR
// module chunks = 0